import { Conditional, Text } from '@consumidor-positivo/aurora';
import classNames from 'classnames';

import { useLoaderProgress } from './hook';
import './styles.scss';

interface LoaderProps {
  isLoading: boolean;
  onComplete: () => void;
}

export const Loader: React.FC<LoaderProps> = ({
  isLoading,
  onComplete,
}) => {
  const progress = useLoaderProgress(isLoading, onComplete);

  return (
    <div className="loader-page">
      <div className="loader-page__content">
        <Text
          as="h3"
          variant="heading-small"
          weight="bold"
          className={classNames('loader-page__text', {
            'loader-page__text--fade-out': progress > 50,
            'loader-page__text--fade-in': progress <= 50,
          })}
        >
          Acessando seu perfil financeiro...
        </Text>

        <Conditional
          condition={progress > 50}
          renderIf={
            <Text
              as="h3"
              weight="bold"
              variant="heading-small"
              className={classNames('loader-page__text', {
                'loader-page__text--fade-in': progress > 50,
              })}
            >
              Analisando dados...
            </Text>
          }
        />
      </div>

      <div className="loader-page__progress-container">
        <div
          className="loader-page__progress-bar"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
};
